import { useDispatch, useSelector } from 'react-redux';
import { setModal, selectModal } from "../../../redux/modalSlice";

export default function BankruptcyFinalizeConfirmationModal() {
  const dispatch = useDispatch();
  const modal = useSelector(selectModal);

  const handleYes = async () => {
    if (typeof modal.extraOptions?.callMethod === 'function') {
      await modal.extraOptions.callMethod();
    }
    dispatch(setModal({
      ...modal,
      extraOptions: { is_bankruptcy_finalize: false }
    }));
  }

  const handleNo = async () => {
    if (typeof modal.extraOptions?.closeMethod === 'function') {
      await modal.extraOptions.closeMethod();
    }
    dispatch(setModal({
      ...modal,
      extraOptions: { is_bankruptcy_finalize: false }
    }));
  };

  return modal.extraOptions?.is_bankruptcy_finalize && modal.extraOptions?.type === 'bankruptcy_finalize_confirmation_modal' ? (
    <div className="modal is-active">
      <div className="modal-background"></div>
      <div className="modal-content">
        <div className="box">
          <h3 className="title has-text-danger is-size-4">Finalize Bankruptcy</h3>
          <p className="has-text-dark my-5">You are about to waive all remaining payments and change the loan status to paid off. This cannot be undone. Are you sure you want to proceed?</p>
          <div className="field is-grouped is-flex is-justify-content-flex-end">
            <div className="buttons">
              <button className="button is-light" onClick={handleNo}>
                No
              </button>
              <button className="button is-danger" onClick={handleYes}>
                Confirm
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : null;
}
